import { Wrapper, Label } from './styled'

function splitColor(color) {
  return color ? color.split(',') : []
}

function getColors(color) {
  const { initial, hover } = typeof color === 'object' ? color : { initial: color, hover: color }

  const [name, group] = initial && splitColor(initial)
  const [nameHover, groupHover] = hover && splitColor(hover)

  return {
    initial: {
      name,
      group,
    },
    hover: hover && {
      name: nameHover,
      group: groupHover,
    },
  }
}

function IconLabel({
  className,
  label,
  Icon,
  orientation = 'horizontal',
  color = 'text',
  onClick,
  dataUserInteractionTracking,
}) {
  const colors = getColors(color)

  return (
    <Wrapper
      className={className}
      orientation={orientation}
      colors={colors}
      onClick={onClick}
      data-user-interaction-tracking={dataUserInteractionTracking}
    >
      {Icon}
      <Label>{label}</Label>
    </Wrapper>
  )
}

export default IconLabel
